import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import React, { useEffect, useState } from 'react'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import PayWithCardForm from './PayWithCardForm';
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable';

const PayWithCardInsurancePopup = ({ onCloseinsurancePopup, ClosePaywithcard, P_Key, stripeSettingId, paymentModel, disableDraggable }) => {
    const uniqueId = "PayWithCardInsurancePopup"
    const [stripePromise, setStripePromise] = useState(null);
    const [IsButtonVisible, setIsButtonVisible] = useState(false)
    const [state, setstate] = useState({
        paymentType: "card",
        terminalId: "",
        readerValidation: false,
        processingTerminalPayment: false,
    });

    const options = {
        mode: "payment",
        amount: 1099,
        currency: "usd",
        // Fully customizable with appearance API.
        appearance: {
            /*...*/
        },
    };
    const handleStateChange = (newState) => {
        setIsButtonVisible(newState);

    };

    useEffect(() => {
        (async () => {
            try {
                let stripePromise = await loadStripe(P_Key);
                setStripePromise(stripePromise);
            } catch (error) {
                ErrorHandlingMessage(error);
            } finally {
            }
        })();
    }, [P_Key, stripeSettingId]);
    return (
        <ReactPortal wrapperId={uniqueId}>
            <div
                data-te-modal-init
                className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
                id="exampleModalScrollable"
                tabIndex={-1}
                aria-labelledby="exampleModalScrollableLabel"
                aria-modal="true"
                data-te-open="true"
            >
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
                    <div
                        data-te-modal-dialog-ref
                        className="relative w-[800px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                    >
                        {/* Header */}
                        <div
                            id={uniqueId}
                            className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
                        >
                            Pay with Card
                            <button onClick={() => ClosePaywithcard(false)} className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2">
                                <img src="/img/crossblack.svg" alt="cross" />
                            </button>
                        </div>

                        <div className="p-5 overflow-y-auto max-h-[70vh]">
                            <div className=''>
                                <Elements
                                    stripe={stripePromise}
                                    options={{ ...options, appearance: { theme: "flat" } }}
                                >

                                    <PayWithCardForm

                                        Model={paymentModel}
                                        onClose={ClosePaywithcard}
                                        stripeSettingId={stripeSettingId}
                                        onCloseinsurancePopup={onCloseinsurancePopup}
                                        ClosePaywithcard={ClosePaywithcard}

                                    />
                                </Elements>
                            </div>
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    )
}

export default PayWithCardInsurancePopup